$(document).ready(function(){

  // CLICK QUANTITY BOX (FULL SYNC)
  $('.btls-price-box').on('click', function(){

    const index = $(this).data('index');

    // Image change
    // $('.pg-atc-btl-img')
    //   .removeClass('active-main')
    //   .filter('[data-index="'+index+'"]')
    //   .addClass('active-main');

    // Quantity active
    $('.btls-price-box').removeClass('active-bottle');
    $(this).addClass('active-bottle');

    // Offer panel change
    $('.price-panel')
      .removeClass('active-bottle')
      .filter('[data-index="'+index+'"]')
      .addClass('active-bottle');
  });


  // âœ… IMAGE CLICK = IMAGE ONLY
  $('.pg-atcbtl-sm-img').on('click', function(){

    const index = $(this).data('index');

    // ONLY image changes
    $('.pg-atc-btl-img')
      .removeClass('active-main')
      .filter('[data-index="'+index+'"]')
      .addClass('active-main');


  });

});
